import userService from '../../api/userService'


// initial state
const state = {
  currentUser: {
    authenticated: false
  }
}

const getters = {
  currentUser: state => state.currentUser
}

const actions = {
  loadUser({ commit }) {
    return userService.getCurrentUser()
      .then(user => commit('SET_USER', user))
  }
}

const mutations = {
  SET_USER(state, user) {
    state.currentUser = user
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js